module.exports = __webpack_public_path__ + "img/car-show.1d7af5ce.jpg";